import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { OrderStatusDetailComponent } from './components/order-status-detail/order-status-detail.component';
import { OrderStatusMyAccountBtnComponent } from './components/order-status-my-account-btn/order-status-my-account-btn.component';
import { OrderStatusSearchComponent } from './components/order-status-search/order-status-search.component';
import { OrderStatusResolver } from './guards/order-status.resolver.guard';
import { OrderStatusLayoutComponent } from './layout/order-status/order-status-layout.component';
import { OrderStatusRoutingModule } from './order-status.routing.module';
import { OrderStatusAnalyticsEffects } from './store/order-status-analytics.effects';
import { OrderStatusEffects } from './store/order-status.effects';
import { orderStatusReducer } from './store/order-status.reducers';

import { OrdersTypeModule } from '@pages/my-account/sections/orders-type/orders-type.module';
import { DuttiCommonModule } from '@shared/common/dutti-common.module';
import { MdFormsModules } from '@shared/forms/forms.module';
import { UiSvgIconModule } from '@shared/ui/svg-icon/svg-icon.module';
import { DialogModule } from '@ui/dialog/dialog.module';

@NgModule({
    declarations: [
        OrderStatusDetailComponent,
        OrderStatusLayoutComponent,
        OrderStatusMyAccountBtnComponent,
        OrderStatusSearchComponent,
    ],
    imports: [
        CommonModule,
        DialogModule,
        // eslint-disable-next-line deprecation/deprecation
        DuttiCommonModule,
        MdFormsModules,
        OrderStatusRoutingModule,
        OrdersTypeModule,
        TranslateModule,
        UiSvgIconModule,
        EffectsModule.forFeature([
            OrderStatusAnalyticsEffects,
            OrderStatusEffects,
        ]),
        StoreModule.forFeature('order-status', orderStatusReducer),
    ],
    providers: [ OrderStatusResolver ],
})
export class OrderStatusModule {}
